import { render, staticRenderFns } from "./ColumnHorizontalSection.vue?vue&type=template&id=832eec7a&scoped=true"
import script from "./ColumnHorizontalSection.vue?vue&type=script&lang=js"
export * from "./ColumnHorizontalSection.vue?vue&type=script&lang=js"
import style0 from "./ColumnHorizontalSection.vue?vue&type=style&index=0&id=832eec7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832eec7a",
  null
  
)

export default component.exports